/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ExportRouteImport } from './routes/export'
import { Route as LiffRouteRouteImport } from './routes/liff/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LiffIndexRouteImport } from './routes/liff/index'
import { Route as LiffWageRouteImport } from './routes/liff/wage'
import { Route as LiffLoginRouteImport } from './routes/liff/login'
import { Route as LiffExpenseRouteImport } from './routes/liff/expense'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as dashboardAdminRouteRouteImport } from './routes/(dashboard)/admin/route'
import { Route as LiffOutstandingIndexRouteImport } from './routes/liff/outstanding/index'
import { Route as dashboardAdminIndexRouteImport } from './routes/(dashboard)/admin/index'
import { Route as LiffOutstandingBillIdRouteImport } from './routes/liff/outstanding/$billId'
import { Route as dashboardAdminSizeRouteImport } from './routes/(dashboard)/admin/size'
import { Route as dashboardAdminSettingsRouteImport } from './routes/(dashboard)/admin/settings'
import { Route as dashboardAdminPicklistRouteImport } from './routes/(dashboard)/admin/picklist'
import { Route as dashboardAdminCustomerRouteImport } from './routes/(dashboard)/admin/customer'
import { Route as dashboardAdminCompanyProfileRouteImport } from './routes/(dashboard)/admin/company-profile'
import { Route as dashboardAdminUserIndexRouteImport } from './routes/(dashboard)/admin/user/index'
import { Route as dashboardAdminTempWorkersIndexRouteImport } from './routes/(dashboard)/admin/temp-workers/index'
import { Route as dashboardAdminRoleIndexRouteImport } from './routes/(dashboard)/admin/role/index'
import { Route as dashboardAdminOutstandingIndexRouteImport } from './routes/(dashboard)/admin/outstanding/index'
import { Route as dashboardAdminExpenseIndexRouteImport } from './routes/(dashboard)/admin/expense/index'
import { Route as dashboardAdminBillIndexRouteImport } from './routes/(dashboard)/admin/bill/index'
import { Route as dashboardAdminUserCreateRouteImport } from './routes/(dashboard)/admin/user/create'
import { Route as dashboardAdminRoleCreateRouteImport } from './routes/(dashboard)/admin/role/create'
import { Route as dashboardAdminOutstandingSettleRouteImport } from './routes/(dashboard)/admin/outstanding/settle'
import { Route as dashboardAdminOutstandingHistoryRouteImport } from './routes/(dashboard)/admin/outstanding/history'
import { Route as dashboardAdminBillCreateRouteImport } from './routes/(dashboard)/admin/bill/create'
import { Route as dashboardAdminTempWorkersIdIndexRouteImport } from './routes/(dashboard)/admin/temp-workers/$id/index'
import { Route as dashboardAdminOutstandingIdIndexRouteImport } from './routes/(dashboard)/admin/outstanding/$id/index'
import { Route as dashboardAdminBillIdIndexRouteImport } from './routes/(dashboard)/admin/bill/$id/index'
import { Route as dashboardAdminUserIdEditRouteImport } from './routes/(dashboard)/admin/user/$id/edit'
import { Route as dashboardAdminRoleIdEditRouteImport } from './routes/(dashboard)/admin/role/$id/edit'
import { Route as dashboardAdminOutstandingIdEditRouteImport } from './routes/(dashboard)/admin/outstanding/$id/edit'
import { Route as dashboardAdminBillIdEditRouteImport } from './routes/(dashboard)/admin/bill/$id/edit'
import { Route as dashboardAdminTempWorkersIdSlipTxnIdRouteImport } from './routes/(dashboard)/admin/temp-workers/$id/slip/$txnId'

const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportRoute = ExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => rootRouteImport,
} as any)
const LiffRouteRoute = LiffRouteRouteImport.update({
  id: '/liff',
  path: '/liff',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LiffIndexRoute = LiffIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LiffRouteRoute,
} as any)
const LiffWageRoute = LiffWageRouteImport.update({
  id: '/wage',
  path: '/wage',
  getParentRoute: () => LiffRouteRoute,
} as any)
const LiffLoginRoute = LiffLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => LiffRouteRoute,
} as any)
const LiffExpenseRoute = LiffExpenseRouteImport.update({
  id: '/expense',
  path: '/expense',
  getParentRoute: () => LiffRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardAdminRouteRoute = dashboardAdminRouteRouteImport.update({
  id: '/(dashboard)/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LiffOutstandingIndexRoute = LiffOutstandingIndexRouteImport.update({
  id: '/outstanding/',
  path: '/outstanding/',
  getParentRoute: () => LiffRouteRoute,
} as any)
const dashboardAdminIndexRoute = dashboardAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => dashboardAdminRouteRoute,
} as any)
const LiffOutstandingBillIdRoute = LiffOutstandingBillIdRouteImport.update({
  id: '/outstanding/$billId',
  path: '/outstanding/$billId',
  getParentRoute: () => LiffRouteRoute,
} as any)
const dashboardAdminSizeRoute = dashboardAdminSizeRouteImport.update({
  id: '/size',
  path: '/size',
  getParentRoute: () => dashboardAdminRouteRoute,
} as any)
const dashboardAdminSettingsRoute = dashboardAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => dashboardAdminRouteRoute,
} as any)
const dashboardAdminPicklistRoute = dashboardAdminPicklistRouteImport.update({
  id: '/picklist',
  path: '/picklist',
  getParentRoute: () => dashboardAdminRouteRoute,
} as any)
const dashboardAdminCustomerRoute = dashboardAdminCustomerRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => dashboardAdminRouteRoute,
} as any)
const dashboardAdminCompanyProfileRoute =
  dashboardAdminCompanyProfileRouteImport.update({
    id: '/company-profile',
    path: '/company-profile',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminUserIndexRoute = dashboardAdminUserIndexRouteImport.update({
  id: '/user/',
  path: '/user/',
  getParentRoute: () => dashboardAdminRouteRoute,
} as any)
const dashboardAdminTempWorkersIndexRoute =
  dashboardAdminTempWorkersIndexRouteImport.update({
    id: '/temp-workers/',
    path: '/temp-workers/',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminRoleIndexRoute = dashboardAdminRoleIndexRouteImport.update({
  id: '/role/',
  path: '/role/',
  getParentRoute: () => dashboardAdminRouteRoute,
} as any)
const dashboardAdminOutstandingIndexRoute =
  dashboardAdminOutstandingIndexRouteImport.update({
    id: '/outstanding/',
    path: '/outstanding/',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminExpenseIndexRoute =
  dashboardAdminExpenseIndexRouteImport.update({
    id: '/expense/',
    path: '/expense/',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminBillIndexRoute = dashboardAdminBillIndexRouteImport.update({
  id: '/bill/',
  path: '/bill/',
  getParentRoute: () => dashboardAdminRouteRoute,
} as any)
const dashboardAdminUserCreateRoute =
  dashboardAdminUserCreateRouteImport.update({
    id: '/user/create',
    path: '/user/create',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminRoleCreateRoute =
  dashboardAdminRoleCreateRouteImport.update({
    id: '/role/create',
    path: '/role/create',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminOutstandingSettleRoute =
  dashboardAdminOutstandingSettleRouteImport.update({
    id: '/outstanding/settle',
    path: '/outstanding/settle',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminOutstandingHistoryRoute =
  dashboardAdminOutstandingHistoryRouteImport.update({
    id: '/outstanding/history',
    path: '/outstanding/history',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminBillCreateRoute =
  dashboardAdminBillCreateRouteImport.update({
    id: '/bill/create',
    path: '/bill/create',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminTempWorkersIdIndexRoute =
  dashboardAdminTempWorkersIdIndexRouteImport.update({
    id: '/temp-workers/$id/',
    path: '/temp-workers/$id/',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminOutstandingIdIndexRoute =
  dashboardAdminOutstandingIdIndexRouteImport.update({
    id: '/outstanding/$id/',
    path: '/outstanding/$id/',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminBillIdIndexRoute =
  dashboardAdminBillIdIndexRouteImport.update({
    id: '/bill/$id/',
    path: '/bill/$id/',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminUserIdEditRoute =
  dashboardAdminUserIdEditRouteImport.update({
    id: '/user/$id/edit',
    path: '/user/$id/edit',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminRoleIdEditRoute =
  dashboardAdminRoleIdEditRouteImport.update({
    id: '/role/$id/edit',
    path: '/role/$id/edit',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminOutstandingIdEditRoute =
  dashboardAdminOutstandingIdEditRouteImport.update({
    id: '/outstanding/$id/edit',
    path: '/outstanding/$id/edit',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminBillIdEditRoute =
  dashboardAdminBillIdEditRouteImport.update({
    id: '/bill/$id/edit',
    path: '/bill/$id/edit',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)
const dashboardAdminTempWorkersIdSlipTxnIdRoute =
  dashboardAdminTempWorkersIdSlipTxnIdRouteImport.update({
    id: '/temp-workers/$id/slip/$txnId',
    path: '/temp-workers/$id/slip/$txnId',
    getParentRoute: () => dashboardAdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/liff': typeof LiffRouteRouteWithChildren
  '/export': typeof ExportRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/admin': typeof dashboardAdminRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/liff/expense': typeof LiffExpenseRoute
  '/liff/login': typeof LiffLoginRoute
  '/liff/wage': typeof LiffWageRoute
  '/liff/': typeof LiffIndexRoute
  '/admin/company-profile': typeof dashboardAdminCompanyProfileRoute
  '/admin/customer': typeof dashboardAdminCustomerRoute
  '/admin/picklist': typeof dashboardAdminPicklistRoute
  '/admin/settings': typeof dashboardAdminSettingsRoute
  '/admin/size': typeof dashboardAdminSizeRoute
  '/liff/outstanding/$billId': typeof LiffOutstandingBillIdRoute
  '/admin/': typeof dashboardAdminIndexRoute
  '/liff/outstanding/': typeof LiffOutstandingIndexRoute
  '/admin/bill/create': typeof dashboardAdminBillCreateRoute
  '/admin/outstanding/history': typeof dashboardAdminOutstandingHistoryRoute
  '/admin/outstanding/settle': typeof dashboardAdminOutstandingSettleRoute
  '/admin/role/create': typeof dashboardAdminRoleCreateRoute
  '/admin/user/create': typeof dashboardAdminUserCreateRoute
  '/admin/bill/': typeof dashboardAdminBillIndexRoute
  '/admin/expense/': typeof dashboardAdminExpenseIndexRoute
  '/admin/outstanding/': typeof dashboardAdminOutstandingIndexRoute
  '/admin/role/': typeof dashboardAdminRoleIndexRoute
  '/admin/temp-workers/': typeof dashboardAdminTempWorkersIndexRoute
  '/admin/user/': typeof dashboardAdminUserIndexRoute
  '/admin/bill/$id/edit': typeof dashboardAdminBillIdEditRoute
  '/admin/outstanding/$id/edit': typeof dashboardAdminOutstandingIdEditRoute
  '/admin/role/$id/edit': typeof dashboardAdminRoleIdEditRoute
  '/admin/user/$id/edit': typeof dashboardAdminUserIdEditRoute
  '/admin/bill/$id/': typeof dashboardAdminBillIdIndexRoute
  '/admin/outstanding/$id/': typeof dashboardAdminOutstandingIdIndexRoute
  '/admin/temp-workers/$id/': typeof dashboardAdminTempWorkersIdIndexRoute
  '/admin/temp-workers/$id/slip/$txnId': typeof dashboardAdminTempWorkersIdSlipTxnIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/export': typeof ExportRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/auth/login': typeof AuthLoginRoute
  '/liff/expense': typeof LiffExpenseRoute
  '/liff/login': typeof LiffLoginRoute
  '/liff/wage': typeof LiffWageRoute
  '/liff': typeof LiffIndexRoute
  '/admin/company-profile': typeof dashboardAdminCompanyProfileRoute
  '/admin/customer': typeof dashboardAdminCustomerRoute
  '/admin/picklist': typeof dashboardAdminPicklistRoute
  '/admin/settings': typeof dashboardAdminSettingsRoute
  '/admin/size': typeof dashboardAdminSizeRoute
  '/liff/outstanding/$billId': typeof LiffOutstandingBillIdRoute
  '/admin': typeof dashboardAdminIndexRoute
  '/liff/outstanding': typeof LiffOutstandingIndexRoute
  '/admin/bill/create': typeof dashboardAdminBillCreateRoute
  '/admin/outstanding/history': typeof dashboardAdminOutstandingHistoryRoute
  '/admin/outstanding/settle': typeof dashboardAdminOutstandingSettleRoute
  '/admin/role/create': typeof dashboardAdminRoleCreateRoute
  '/admin/user/create': typeof dashboardAdminUserCreateRoute
  '/admin/bill': typeof dashboardAdminBillIndexRoute
  '/admin/expense': typeof dashboardAdminExpenseIndexRoute
  '/admin/outstanding': typeof dashboardAdminOutstandingIndexRoute
  '/admin/role': typeof dashboardAdminRoleIndexRoute
  '/admin/temp-workers': typeof dashboardAdminTempWorkersIndexRoute
  '/admin/user': typeof dashboardAdminUserIndexRoute
  '/admin/bill/$id/edit': typeof dashboardAdminBillIdEditRoute
  '/admin/outstanding/$id/edit': typeof dashboardAdminOutstandingIdEditRoute
  '/admin/role/$id/edit': typeof dashboardAdminRoleIdEditRoute
  '/admin/user/$id/edit': typeof dashboardAdminUserIdEditRoute
  '/admin/bill/$id': typeof dashboardAdminBillIdIndexRoute
  '/admin/outstanding/$id': typeof dashboardAdminOutstandingIdIndexRoute
  '/admin/temp-workers/$id': typeof dashboardAdminTempWorkersIdIndexRoute
  '/admin/temp-workers/$id/slip/$txnId': typeof dashboardAdminTempWorkersIdSlipTxnIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/liff': typeof LiffRouteRouteWithChildren
  '/export': typeof ExportRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/(dashboard)/admin': typeof dashboardAdminRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/liff/expense': typeof LiffExpenseRoute
  '/liff/login': typeof LiffLoginRoute
  '/liff/wage': typeof LiffWageRoute
  '/liff/': typeof LiffIndexRoute
  '/(dashboard)/admin/company-profile': typeof dashboardAdminCompanyProfileRoute
  '/(dashboard)/admin/customer': typeof dashboardAdminCustomerRoute
  '/(dashboard)/admin/picklist': typeof dashboardAdminPicklistRoute
  '/(dashboard)/admin/settings': typeof dashboardAdminSettingsRoute
  '/(dashboard)/admin/size': typeof dashboardAdminSizeRoute
  '/liff/outstanding/$billId': typeof LiffOutstandingBillIdRoute
  '/(dashboard)/admin/': typeof dashboardAdminIndexRoute
  '/liff/outstanding/': typeof LiffOutstandingIndexRoute
  '/(dashboard)/admin/bill/create': typeof dashboardAdminBillCreateRoute
  '/(dashboard)/admin/outstanding/history': typeof dashboardAdminOutstandingHistoryRoute
  '/(dashboard)/admin/outstanding/settle': typeof dashboardAdminOutstandingSettleRoute
  '/(dashboard)/admin/role/create': typeof dashboardAdminRoleCreateRoute
  '/(dashboard)/admin/user/create': typeof dashboardAdminUserCreateRoute
  '/(dashboard)/admin/bill/': typeof dashboardAdminBillIndexRoute
  '/(dashboard)/admin/expense/': typeof dashboardAdminExpenseIndexRoute
  '/(dashboard)/admin/outstanding/': typeof dashboardAdminOutstandingIndexRoute
  '/(dashboard)/admin/role/': typeof dashboardAdminRoleIndexRoute
  '/(dashboard)/admin/temp-workers/': typeof dashboardAdminTempWorkersIndexRoute
  '/(dashboard)/admin/user/': typeof dashboardAdminUserIndexRoute
  '/(dashboard)/admin/bill/$id/edit': typeof dashboardAdminBillIdEditRoute
  '/(dashboard)/admin/outstanding/$id/edit': typeof dashboardAdminOutstandingIdEditRoute
  '/(dashboard)/admin/role/$id/edit': typeof dashboardAdminRoleIdEditRoute
  '/(dashboard)/admin/user/$id/edit': typeof dashboardAdminUserIdEditRoute
  '/(dashboard)/admin/bill/$id/': typeof dashboardAdminBillIdIndexRoute
  '/(dashboard)/admin/outstanding/$id/': typeof dashboardAdminOutstandingIdIndexRoute
  '/(dashboard)/admin/temp-workers/$id/': typeof dashboardAdminTempWorkersIdIndexRoute
  '/(dashboard)/admin/temp-workers/$id/slip/$txnId': typeof dashboardAdminTempWorkersIdSlipTxnIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/liff'
    | '/export'
    | '/privacy-policy'
    | '/admin'
    | '/auth/login'
    | '/liff/expense'
    | '/liff/login'
    | '/liff/wage'
    | '/liff/'
    | '/admin/company-profile'
    | '/admin/customer'
    | '/admin/picklist'
    | '/admin/settings'
    | '/admin/size'
    | '/liff/outstanding/$billId'
    | '/admin/'
    | '/liff/outstanding/'
    | '/admin/bill/create'
    | '/admin/outstanding/history'
    | '/admin/outstanding/settle'
    | '/admin/role/create'
    | '/admin/user/create'
    | '/admin/bill/'
    | '/admin/expense/'
    | '/admin/outstanding/'
    | '/admin/role/'
    | '/admin/temp-workers/'
    | '/admin/user/'
    | '/admin/bill/$id/edit'
    | '/admin/outstanding/$id/edit'
    | '/admin/role/$id/edit'
    | '/admin/user/$id/edit'
    | '/admin/bill/$id/'
    | '/admin/outstanding/$id/'
    | '/admin/temp-workers/$id/'
    | '/admin/temp-workers/$id/slip/$txnId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/export'
    | '/privacy-policy'
    | '/auth/login'
    | '/liff/expense'
    | '/liff/login'
    | '/liff/wage'
    | '/liff'
    | '/admin/company-profile'
    | '/admin/customer'
    | '/admin/picklist'
    | '/admin/settings'
    | '/admin/size'
    | '/liff/outstanding/$billId'
    | '/admin'
    | '/liff/outstanding'
    | '/admin/bill/create'
    | '/admin/outstanding/history'
    | '/admin/outstanding/settle'
    | '/admin/role/create'
    | '/admin/user/create'
    | '/admin/bill'
    | '/admin/expense'
    | '/admin/outstanding'
    | '/admin/role'
    | '/admin/temp-workers'
    | '/admin/user'
    | '/admin/bill/$id/edit'
    | '/admin/outstanding/$id/edit'
    | '/admin/role/$id/edit'
    | '/admin/user/$id/edit'
    | '/admin/bill/$id'
    | '/admin/outstanding/$id'
    | '/admin/temp-workers/$id'
    | '/admin/temp-workers/$id/slip/$txnId'
  id:
    | '__root__'
    | '/'
    | '/liff'
    | '/export'
    | '/privacy-policy'
    | '/(dashboard)/admin'
    | '/auth/login'
    | '/liff/expense'
    | '/liff/login'
    | '/liff/wage'
    | '/liff/'
    | '/(dashboard)/admin/company-profile'
    | '/(dashboard)/admin/customer'
    | '/(dashboard)/admin/picklist'
    | '/(dashboard)/admin/settings'
    | '/(dashboard)/admin/size'
    | '/liff/outstanding/$billId'
    | '/(dashboard)/admin/'
    | '/liff/outstanding/'
    | '/(dashboard)/admin/bill/create'
    | '/(dashboard)/admin/outstanding/history'
    | '/(dashboard)/admin/outstanding/settle'
    | '/(dashboard)/admin/role/create'
    | '/(dashboard)/admin/user/create'
    | '/(dashboard)/admin/bill/'
    | '/(dashboard)/admin/expense/'
    | '/(dashboard)/admin/outstanding/'
    | '/(dashboard)/admin/role/'
    | '/(dashboard)/admin/temp-workers/'
    | '/(dashboard)/admin/user/'
    | '/(dashboard)/admin/bill/$id/edit'
    | '/(dashboard)/admin/outstanding/$id/edit'
    | '/(dashboard)/admin/role/$id/edit'
    | '/(dashboard)/admin/user/$id/edit'
    | '/(dashboard)/admin/bill/$id/'
    | '/(dashboard)/admin/outstanding/$id/'
    | '/(dashboard)/admin/temp-workers/$id/'
    | '/(dashboard)/admin/temp-workers/$id/slip/$txnId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LiffRouteRoute: typeof LiffRouteRouteWithChildren
  ExportRoute: typeof ExportRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  dashboardAdminRouteRoute: typeof dashboardAdminRouteRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export': {
      id: '/export'
      path: '/export'
      fullPath: '/export'
      preLoaderRoute: typeof ExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/liff': {
      id: '/liff'
      path: '/liff'
      fullPath: '/liff'
      preLoaderRoute: typeof LiffRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/liff/': {
      id: '/liff/'
      path: '/'
      fullPath: '/liff/'
      preLoaderRoute: typeof LiffIndexRouteImport
      parentRoute: typeof LiffRouteRoute
    }
    '/liff/wage': {
      id: '/liff/wage'
      path: '/wage'
      fullPath: '/liff/wage'
      preLoaderRoute: typeof LiffWageRouteImport
      parentRoute: typeof LiffRouteRoute
    }
    '/liff/login': {
      id: '/liff/login'
      path: '/login'
      fullPath: '/liff/login'
      preLoaderRoute: typeof LiffLoginRouteImport
      parentRoute: typeof LiffRouteRoute
    }
    '/liff/expense': {
      id: '/liff/expense'
      path: '/expense'
      fullPath: '/liff/expense'
      preLoaderRoute: typeof LiffExpenseRouteImport
      parentRoute: typeof LiffRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/admin': {
      id: '/(dashboard)/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof dashboardAdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/liff/outstanding/': {
      id: '/liff/outstanding/'
      path: '/outstanding'
      fullPath: '/liff/outstanding/'
      preLoaderRoute: typeof LiffOutstandingIndexRouteImport
      parentRoute: typeof LiffRouteRoute
    }
    '/(dashboard)/admin/': {
      id: '/(dashboard)/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof dashboardAdminIndexRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/liff/outstanding/$billId': {
      id: '/liff/outstanding/$billId'
      path: '/outstanding/$billId'
      fullPath: '/liff/outstanding/$billId'
      preLoaderRoute: typeof LiffOutstandingBillIdRouteImport
      parentRoute: typeof LiffRouteRoute
    }
    '/(dashboard)/admin/size': {
      id: '/(dashboard)/admin/size'
      path: '/size'
      fullPath: '/admin/size'
      preLoaderRoute: typeof dashboardAdminSizeRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/settings': {
      id: '/(dashboard)/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof dashboardAdminSettingsRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/picklist': {
      id: '/(dashboard)/admin/picklist'
      path: '/picklist'
      fullPath: '/admin/picklist'
      preLoaderRoute: typeof dashboardAdminPicklistRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/customer': {
      id: '/(dashboard)/admin/customer'
      path: '/customer'
      fullPath: '/admin/customer'
      preLoaderRoute: typeof dashboardAdminCustomerRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/company-profile': {
      id: '/(dashboard)/admin/company-profile'
      path: '/company-profile'
      fullPath: '/admin/company-profile'
      preLoaderRoute: typeof dashboardAdminCompanyProfileRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/user/': {
      id: '/(dashboard)/admin/user/'
      path: '/user'
      fullPath: '/admin/user/'
      preLoaderRoute: typeof dashboardAdminUserIndexRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/temp-workers/': {
      id: '/(dashboard)/admin/temp-workers/'
      path: '/temp-workers'
      fullPath: '/admin/temp-workers/'
      preLoaderRoute: typeof dashboardAdminTempWorkersIndexRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/role/': {
      id: '/(dashboard)/admin/role/'
      path: '/role'
      fullPath: '/admin/role/'
      preLoaderRoute: typeof dashboardAdminRoleIndexRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/outstanding/': {
      id: '/(dashboard)/admin/outstanding/'
      path: '/outstanding'
      fullPath: '/admin/outstanding/'
      preLoaderRoute: typeof dashboardAdminOutstandingIndexRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/expense/': {
      id: '/(dashboard)/admin/expense/'
      path: '/expense'
      fullPath: '/admin/expense/'
      preLoaderRoute: typeof dashboardAdminExpenseIndexRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/bill/': {
      id: '/(dashboard)/admin/bill/'
      path: '/bill'
      fullPath: '/admin/bill/'
      preLoaderRoute: typeof dashboardAdminBillIndexRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/user/create': {
      id: '/(dashboard)/admin/user/create'
      path: '/user/create'
      fullPath: '/admin/user/create'
      preLoaderRoute: typeof dashboardAdminUserCreateRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/role/create': {
      id: '/(dashboard)/admin/role/create'
      path: '/role/create'
      fullPath: '/admin/role/create'
      preLoaderRoute: typeof dashboardAdminRoleCreateRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/outstanding/settle': {
      id: '/(dashboard)/admin/outstanding/settle'
      path: '/outstanding/settle'
      fullPath: '/admin/outstanding/settle'
      preLoaderRoute: typeof dashboardAdminOutstandingSettleRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/outstanding/history': {
      id: '/(dashboard)/admin/outstanding/history'
      path: '/outstanding/history'
      fullPath: '/admin/outstanding/history'
      preLoaderRoute: typeof dashboardAdminOutstandingHistoryRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/bill/create': {
      id: '/(dashboard)/admin/bill/create'
      path: '/bill/create'
      fullPath: '/admin/bill/create'
      preLoaderRoute: typeof dashboardAdminBillCreateRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/temp-workers/$id/': {
      id: '/(dashboard)/admin/temp-workers/$id/'
      path: '/temp-workers/$id'
      fullPath: '/admin/temp-workers/$id/'
      preLoaderRoute: typeof dashboardAdminTempWorkersIdIndexRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/outstanding/$id/': {
      id: '/(dashboard)/admin/outstanding/$id/'
      path: '/outstanding/$id'
      fullPath: '/admin/outstanding/$id/'
      preLoaderRoute: typeof dashboardAdminOutstandingIdIndexRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/bill/$id/': {
      id: '/(dashboard)/admin/bill/$id/'
      path: '/bill/$id'
      fullPath: '/admin/bill/$id/'
      preLoaderRoute: typeof dashboardAdminBillIdIndexRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/user/$id/edit': {
      id: '/(dashboard)/admin/user/$id/edit'
      path: '/user/$id/edit'
      fullPath: '/admin/user/$id/edit'
      preLoaderRoute: typeof dashboardAdminUserIdEditRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/role/$id/edit': {
      id: '/(dashboard)/admin/role/$id/edit'
      path: '/role/$id/edit'
      fullPath: '/admin/role/$id/edit'
      preLoaderRoute: typeof dashboardAdminRoleIdEditRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/outstanding/$id/edit': {
      id: '/(dashboard)/admin/outstanding/$id/edit'
      path: '/outstanding/$id/edit'
      fullPath: '/admin/outstanding/$id/edit'
      preLoaderRoute: typeof dashboardAdminOutstandingIdEditRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/bill/$id/edit': {
      id: '/(dashboard)/admin/bill/$id/edit'
      path: '/bill/$id/edit'
      fullPath: '/admin/bill/$id/edit'
      preLoaderRoute: typeof dashboardAdminBillIdEditRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
    '/(dashboard)/admin/temp-workers/$id/slip/$txnId': {
      id: '/(dashboard)/admin/temp-workers/$id/slip/$txnId'
      path: '/temp-workers/$id/slip/$txnId'
      fullPath: '/admin/temp-workers/$id/slip/$txnId'
      preLoaderRoute: typeof dashboardAdminTempWorkersIdSlipTxnIdRouteImport
      parentRoute: typeof dashboardAdminRouteRoute
    }
  }
}

interface LiffRouteRouteChildren {
  LiffExpenseRoute: typeof LiffExpenseRoute
  LiffLoginRoute: typeof LiffLoginRoute
  LiffWageRoute: typeof LiffWageRoute
  LiffIndexRoute: typeof LiffIndexRoute
  LiffOutstandingBillIdRoute: typeof LiffOutstandingBillIdRoute
  LiffOutstandingIndexRoute: typeof LiffOutstandingIndexRoute
}

const LiffRouteRouteChildren: LiffRouteRouteChildren = {
  LiffExpenseRoute: LiffExpenseRoute,
  LiffLoginRoute: LiffLoginRoute,
  LiffWageRoute: LiffWageRoute,
  LiffIndexRoute: LiffIndexRoute,
  LiffOutstandingBillIdRoute: LiffOutstandingBillIdRoute,
  LiffOutstandingIndexRoute: LiffOutstandingIndexRoute,
}

const LiffRouteRouteWithChildren = LiffRouteRoute._addFileChildren(
  LiffRouteRouteChildren,
)

interface dashboardAdminRouteRouteChildren {
  dashboardAdminCompanyProfileRoute: typeof dashboardAdminCompanyProfileRoute
  dashboardAdminCustomerRoute: typeof dashboardAdminCustomerRoute
  dashboardAdminPicklistRoute: typeof dashboardAdminPicklistRoute
  dashboardAdminSettingsRoute: typeof dashboardAdminSettingsRoute
  dashboardAdminSizeRoute: typeof dashboardAdminSizeRoute
  dashboardAdminIndexRoute: typeof dashboardAdminIndexRoute
  dashboardAdminBillCreateRoute: typeof dashboardAdminBillCreateRoute
  dashboardAdminOutstandingHistoryRoute: typeof dashboardAdminOutstandingHistoryRoute
  dashboardAdminOutstandingSettleRoute: typeof dashboardAdminOutstandingSettleRoute
  dashboardAdminRoleCreateRoute: typeof dashboardAdminRoleCreateRoute
  dashboardAdminUserCreateRoute: typeof dashboardAdminUserCreateRoute
  dashboardAdminBillIndexRoute: typeof dashboardAdminBillIndexRoute
  dashboardAdminExpenseIndexRoute: typeof dashboardAdminExpenseIndexRoute
  dashboardAdminOutstandingIndexRoute: typeof dashboardAdminOutstandingIndexRoute
  dashboardAdminRoleIndexRoute: typeof dashboardAdminRoleIndexRoute
  dashboardAdminTempWorkersIndexRoute: typeof dashboardAdminTempWorkersIndexRoute
  dashboardAdminUserIndexRoute: typeof dashboardAdminUserIndexRoute
  dashboardAdminBillIdEditRoute: typeof dashboardAdminBillIdEditRoute
  dashboardAdminOutstandingIdEditRoute: typeof dashboardAdminOutstandingIdEditRoute
  dashboardAdminRoleIdEditRoute: typeof dashboardAdminRoleIdEditRoute
  dashboardAdminUserIdEditRoute: typeof dashboardAdminUserIdEditRoute
  dashboardAdminBillIdIndexRoute: typeof dashboardAdminBillIdIndexRoute
  dashboardAdminOutstandingIdIndexRoute: typeof dashboardAdminOutstandingIdIndexRoute
  dashboardAdminTempWorkersIdIndexRoute: typeof dashboardAdminTempWorkersIdIndexRoute
  dashboardAdminTempWorkersIdSlipTxnIdRoute: typeof dashboardAdminTempWorkersIdSlipTxnIdRoute
}

const dashboardAdminRouteRouteChildren: dashboardAdminRouteRouteChildren = {
  dashboardAdminCompanyProfileRoute: dashboardAdminCompanyProfileRoute,
  dashboardAdminCustomerRoute: dashboardAdminCustomerRoute,
  dashboardAdminPicklistRoute: dashboardAdminPicklistRoute,
  dashboardAdminSettingsRoute: dashboardAdminSettingsRoute,
  dashboardAdminSizeRoute: dashboardAdminSizeRoute,
  dashboardAdminIndexRoute: dashboardAdminIndexRoute,
  dashboardAdminBillCreateRoute: dashboardAdminBillCreateRoute,
  dashboardAdminOutstandingHistoryRoute: dashboardAdminOutstandingHistoryRoute,
  dashboardAdminOutstandingSettleRoute: dashboardAdminOutstandingSettleRoute,
  dashboardAdminRoleCreateRoute: dashboardAdminRoleCreateRoute,
  dashboardAdminUserCreateRoute: dashboardAdminUserCreateRoute,
  dashboardAdminBillIndexRoute: dashboardAdminBillIndexRoute,
  dashboardAdminExpenseIndexRoute: dashboardAdminExpenseIndexRoute,
  dashboardAdminOutstandingIndexRoute: dashboardAdminOutstandingIndexRoute,
  dashboardAdminRoleIndexRoute: dashboardAdminRoleIndexRoute,
  dashboardAdminTempWorkersIndexRoute: dashboardAdminTempWorkersIndexRoute,
  dashboardAdminUserIndexRoute: dashboardAdminUserIndexRoute,
  dashboardAdminBillIdEditRoute: dashboardAdminBillIdEditRoute,
  dashboardAdminOutstandingIdEditRoute: dashboardAdminOutstandingIdEditRoute,
  dashboardAdminRoleIdEditRoute: dashboardAdminRoleIdEditRoute,
  dashboardAdminUserIdEditRoute: dashboardAdminUserIdEditRoute,
  dashboardAdminBillIdIndexRoute: dashboardAdminBillIdIndexRoute,
  dashboardAdminOutstandingIdIndexRoute: dashboardAdminOutstandingIdIndexRoute,
  dashboardAdminTempWorkersIdIndexRoute: dashboardAdminTempWorkersIdIndexRoute,
  dashboardAdminTempWorkersIdSlipTxnIdRoute:
    dashboardAdminTempWorkersIdSlipTxnIdRoute,
}

const dashboardAdminRouteRouteWithChildren =
  dashboardAdminRouteRoute._addFileChildren(dashboardAdminRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LiffRouteRoute: LiffRouteRouteWithChildren,
  ExportRoute: ExportRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  dashboardAdminRouteRoute: dashboardAdminRouteRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
